import React from 'react'
import PropTypes from 'prop-types'

import { Route, Switch } from 'react-router-dom'

import _ from 'lodash'

import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'

import NoMatch from '../NoMatch'
import Loading from '../loading/Loading'

import Edit from '../edit/Edit'
import Explore from '../explore/Explore'
import Parse from '../parse/Parse'
import Search from '../search/Search'
import Usage from '../usage/Usage'
import Welcome from '../welcome/Welcome'

import MatchAPI from '../../api/MatchAPI'

// Import constants
import { } from '../../constants'

const styles = theme => ({
  root: { display: 'flex', flexWrap: 'wrap', width: '100%', height: '100%' },
  paper: {
    width: '100%',
    height: '100%',
    position: 'relative',
    textAlign: 'center',
    padding: theme.spacing.unit
  },
  header: {
    margin: theme.spacing.unit*2
  }
})

class Home extends React.Component {

  matchAPI

  constructor() {
    super()
    this.state = {
      error: '',
      address: {},
      result: {}
    }
    this.handleSearch = this.handleSearch.bind(this)
    this.handleLookup = this.handleLookup.bind(this)
  }

  componentWillMount() {
    const { handleRefreshProfile, profile } = this.props
    if (_.isEmpty(profile)) handleRefreshProfile()
  }

  async handleSearch(environment, locationType, query, opts) {
    // DEBUG && console.log({ environment, locationType, query, opts })
    const result = await this.matchAPI.geocode(environment, locationType, query, opts)
    this.setState({ result })
  }

  async handleLookup(environment, locationType, id) {
    // DEBUG && console.log({ environment, locationType, id })
    const address = await this.matchAPI.lookup(environment, locationType, id)
    this.setState({ address })
  }

  render() {
    const { classes, handleLogout, isAuthenticated, isSetup, apiKey, clientId,
      profile } = this.props
    const { address, result } = this.state
    const { prefs } = profile

    // Instantiate the APIs if not already setup
    if ((!this.intelAPI || !this.matchAPI) &&
      _.get(profile, 'name')) {
      this.matchAPI = new MatchAPI(apiKey, clientId, profile.name)
    }

    return (
      <div className={classes.root}>
        { (!isAuthenticated || _.isEmpty(profile)) && <Loading /> }
        { isAuthenticated && isSetup && profile && prefs &&
          <Switch>
            <Route exact path='/' render={props => <Welcome prefs={prefs} />} />
            <Route exact path='/edit' render={props => <Edit />} />
            <Route exact path='/explore' render={props => <Explore />} />
            <Route exact path='/parse' render={props => <Parse />} />
            <Route exact path='/search' render={props =>
              <Search
                prefs={prefs}
                handleLookup={this.handleLookup}
                handleSearch={this.handleSearch}
                address={address}
                result={result}
              />
            } />
            <Route exact path='/usage' render={props => <Usage />} />
            <Route component={NoMatch} />
          </Switch>
        }
        { isAuthenticated && !isSetup &&
          <Paper className={classes.paper} elevation={1}>
            <Typography gutterBottom variant='headline' color='secondary' className={classes.header}>
              User Awaiting Setup
            </Typography>
            <Typography>
            No profile was found for your user account: if you have just signed up, we will contact you
            once your account is fully activated.  If you have received a confirmation email that your
            account has been set up please <a href='/' onClick={handleLogout}>click here to logout</a>.
            Once you log back in again you should have access to the application.  <br/><br/>If the issue persists
            please contact <a href='mailto:support@addresscloud.com'>support@addresscloud.com</a>
            </Typography>
          </Paper>
        }
      </div>
    )
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired,
  handleLogout: PropTypes.func.isRequired,
  handleRefreshProfile: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isSetup: PropTypes.bool.isRequired,
  apiKey: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  profile: PropTypes.object.isRequired,
}

export default withStyles(styles)(Home)
